<script>
// 服务商或工程师名片

import { alertComfirm, alertError } from '@/helpers/swal'

export default {
  props: {
    targetId: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    tel: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    },
    specialStatus:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconAlt() {
      if (!this.title) {
        return ''
      }
      return this.title.charAt(0).toUpperCase()
    },
    
  },
  methods: {
    exchangeBtnClick() {
      if (!this.editable) {
        alertError(this.$t('page.notEditable'))
        return;
      }
      this.$emit('exchange', this.targetId)
    },
    deleteBtnClick() {
      if (!this.editable || this.specialStatus) {
        alertError(this.$t('page.notEditable'))
        return;
      }
      alertComfirm(this.$t('page.deleteConfirm'), '').then(res => {
        if (res) {
          this.$emit('deleted', this.targetId)
        }
      })
    }
  }
}
</script>
<template>
  <div class="border rounded border-dashed p-3">
    <div class="d-flex align-items-center">
      <div class="flex-shrink-0 me-3">
        <div class="avatar-sm">
          <div class="avatar-title bg-primary text-light rounded-circle">
            <img v-if="icon" :src="icon" alt="" height="50" />
            <span v-else>{{ iconAlt }}</span>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 overflow-hidden">
        <h5 class="fs-13 mb-1">
          {{ title }}
        </h5>
        <div>{{ tel }}</div>
      </div>
      <div class="flex-shrink-0 ms-2 d-flex" >
        <div v-if="editable" class="avatar-xs me-2" @click="exchangeBtnClick">
          <div class="avatar-title rounded-circle bg-light text-primary cursor-pointer">
            <i class="las la-exchange-alt"></i>
          </div>
        </div>
        <div v-if="specialStatus|| editable" class="avatar-xs" @click="deleteBtnClick">
          <div class="avatar-title rounded-circle bg-light text-danger cursor-pointer">
            <i class="ri-delete-bin-5-line"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
